<template>
  <div class="box">
    <div class="banner">
      <div v-for="(item, index) in cateList" :key="index">
        <div class="banner_content" @click="changeBanner(index)">
          <div
            :class="
              index == tabIndex
                ? 'banner_title banner_title_active'
                : 'banner_title'
            "
          >
            {{ item.name }}
          </div>
          <div class="banner_icon" v-if="tabIndex == index"></div>
        </div>
      </div>
    </div>
    <div style="position: relative; padding: 0.32rem 0.1rem">
      <div class="main-bottom-box">
        <div v-for="(item, index) in pageListRow" :key="index">
          <saiItem v-if="item.type_id == 1" :row="item.info"></saiItem>
          <goodsItem v-if="item.type_id == 3" :row="item.info"> </goodsItem>
          <newsItem v-if="item.type_id == 4" :row="item.info"> </newsItem>
          <peiItem v-if="item.type_id == 2" :row="item.info"> </peiItem>
        </div>
        <!-- <saiItem
          v-for="(sai, index) in pageListRow.sai"
          :row="sai"
          v-if="tabIndex == 0 || tabIndex == 1"
          :key="index"
        ></saiItem>
        <goodsItem
          v-for="(goods, index2) in pageListRow.goods"
          v-if="tabIndex == 0 || tabIndex == 3"
          :row="goods"
          :key="index2"
        >
        </goodsItem>
        <newsItem
          v-for="(news, index3) in pageListRow.news"
          v-if="tabIndex == 0 || tabIndex == 4"
          :row="news"
          :key="index3"
        >
        </newsItem>
        <peiItem
          v-for="(huiyi, index4) in pageListRow.huiyi"
          v-if="tabIndex == 0 || tabIndex == 2"
          :row="huiyi"
          :key="index4"
        >
        </peiItem> -->
      </div>
    </div>
  </div>
</template>
<style scoped>
.box {
  background: #f8f8f8;
  overflow: scroll;
  width: 100%;
  height: 100%;
  position: absolute;
}
.banner {
  display: flex;
  justify-content: space-between;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  /* height: 1rem; */
  background: #ffffff;
  text-align: center;
}
.banner_title {
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 0.46rem;
}
.banner_title_active {
  font-size: 0.36rem;
  font-weight: 900;
  line-height: 0.5rem;
}
.banner_icon {
  width: 0.8rem;
  height: 3px;
  background: #fcab16;
  border-radius: 2px;
  margin-top: 0.08rem;
}
.main-bottom-box {
  display: flex;
  justify-content: space-between;
  width: 710rpx;
  margin: 0 auto;
  flex-wrap: wrap;
}
</style>
<script>
import Vue from "vue";
import saiItem from "./components/SaiItem.vue";
import goodsItem from "./components/GoodsItem.vue";
import newsItem from "./components/NewsItem.vue";
import peiItem from "./components/PeiItem.vue";
import {
  Cell,
  CellGroup,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Sku,
  Toast,
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(GoodsAction)
  .use(GoodsActionIcon)
  .use(GoodsActionButton)
  .use(Sku)
  .use(Toast);
export default {
  name: "Collection",
  data() {
    return {
      cateList: [
        { name: "全部", value: 0 },
        { name: "商品", value: 1 },
        { name: "新闻", value: 2 },
        { name: "下载", value: 3 },
        { name: "课程", value: 4 },
      ],
      formData: {},
      pageListRow: {},
      tabIndex: 0,
    };
  },
  components: {
    goodsItem,
    peiItem,
    newsItem,
    saiItem,
  },
  mounted() {
    document.title = "收藏";
    this.fetch(0);
  },
  methods: {
    changeBanner(val) {
      this.tabIndex = val;
      this.fetch(val)
    },
    fetch(val) {
      let that = this;
      this.$api.get("/api/index/collectionData", {type:val}, (res) => {
        if (res.code == 555) {
          console.log("error");
        }
        that.pageListRow = res.data.pageList.data.list;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Collection.vue?91fa0222